import React from 'react';
import { Image } from '@cian/ui-kit';

import { IArticlesMainAttributesSchema } from '../../repositories/journal/entities/journal/ArticlesMainAttributesSchema';
import * as s from './MainArticleSimplified.css';

interface IMainArticleSimplified extends Pick<IArticlesMainAttributesSchema, 'title' | 'image'> {
  onClick(e: React.MouseEvent): void;
}

/** Топовая статья на Главной (упрощенный вид) */
export const MainArticleSimplified = ({ image, title, onClick }: IMainArticleSimplified) => {
  return (
    <div className={`${s['wrapper']}`} onClick={onClick}>
      <div className={`${s['title']}`}>{title}</div>

      <Image
        alt={title}
        borderRadius={'4px'}
        objectFit="cover"
        preloader
        src={image || ''}
        theme="light"
        title={title}
      />
    </div>
  );
};
